<template>
  <!-- Mirrored by _content_header_html in backend/app.py -->
  <header class="guide-header">
    <div class="guide-header-inner">
      <router-link class="guide-brand" :to="prefix || '/'">
        <img src="/brain-icon-96.jpg" alt="" width="28" height="28" />
        <span>Remote EMDR</span>
      </router-link>
      <nav class="guide-nav">
        <router-link :to="`${prefix}/guides`">{{ labels.navGuides }}</router-link>
        <router-link :to="`${prefix}/about`">{{ labels.navAbout }}</router-link>
        <router-link :to="`${prefix}/contact`">{{ labels.navContact }}</router-link>
        <language-menu :path="path" :languages="languages" />
      </nav>
    </div>
  </header>
</template>

<script>
import { contentLabels } from '../contentPages';
import { localePrefix } from '../i18n/locales';
import LanguageMenu from './LanguageMenu.vue';

export default {
  components: { LanguageMenu },
  props: {
    // This page without a language prefix, e.g. '/guides/emdr-phases'
    path: { type: String, required: true },
    // Languages the page exists in; all of them when not given
    languages: { type: Array, default: undefined }
  },
  computed: {
    labels() {
      return contentLabels(this.$locale);
    },
    prefix() {
      return localePrefix(this.$locale);
    }
  }
};
</script>
